import React from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { Grid, Drawer } from '@material-ui/core';
import IntegrityFilterAttachmentDrawerHeader from 'features/wells/integrity/attachments/filter/IntegrityFilterAttachmentDrawerHeader';
import IntegrityFilterAttachmentDrawerContent from 'features/wells/integrity/attachments/filter/IntegrityFilterAttachmentDrawerContent';

const IntegrityFilterAttachmentDrawer = ({
  isOpen,
  classes,
  attachments,
  toggleDrawer,
  filters,
  setFilters,
}) => {
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={toggleDrawer}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <Grid className={classes.drawerHeader}>
        <IntegrityFilterAttachmentDrawerHeader toggleDrawer={toggleDrawer} />
      </Grid>
      <Grid className={classes.drawerContent}>
        <IntegrityFilterAttachmentDrawerContent
          toggleDrawer={toggleDrawer}
          attachments={attachments}
          filters={filters}
          setFilters={setFilters}
        />
      </Grid>
    </Drawer>
  );
};

const styles = (theme) => ({
  drawerPaper: {
    width: '30%',
    minWidth: 300,
    background: theme.palette.background.default,
  },
  drawerHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    background: theme.palette.background.default,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderBottom: `2px solid ${theme.palette.table.row.hover}`,
  },
  drawerContent: {
    padding: theme.spacing(2),
    overflowY: 'scroll-y',
    margin: `0 ${theme.spacing(1)}px 0 ${theme.spacing(1)}px`,
  },
});

export default withStyles(styles)(IntegrityFilterAttachmentDrawer);
